import { TextMode } from "@plansoft-configuration-renderer/framework";
import { INFO_LAYOUT_PROPS_DEFAULTS } from "../Info/Info.defaults";
import { AttributeValueContentType } from "./AttributeValueContentType";
const VALUE_CONTENT_ATTRIBUTE_NAME_DEFAULTS = {
    textMode: TextMode.PlainText,
};
const VALUE_CONTENT_DESCRIPTION_DEFAULTS = {
    textMode: TextMode.Markdown,
};
const VALUE_CONTENT_NAME_DEFAULTS = {
    textMode: TextMode.PlainText,
};
const VALUE_CONTENT_VALUE_DEFAULTS = {
    textMode: TextMode.PlainText,
};
export const VALUE_CONTENT_DEFAULTS = {
    [AttributeValueContentType.Value]: VALUE_CONTENT_VALUE_DEFAULTS,
    [AttributeValueContentType.Name]: VALUE_CONTENT_NAME_DEFAULTS,
    [AttributeValueContentType.Description]: VALUE_CONTENT_DESCRIPTION_DEFAULTS,
    [AttributeValueContentType.Help]: INFO_LAYOUT_PROPS_DEFAULTS,
    [AttributeValueContentType.AttributeName]: VALUE_CONTENT_ATTRIBUTE_NAME_DEFAULTS,
};
//# sourceMappingURL=ValueContent.defaults.js.map